<template>
  <b-navbar toggleable="md" type="dark" variant="primary">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand to='root'>
      <a class="navbar-brand" target="_blank" href="http://www.missouri.edu"><img src="img/mu-logo-tiny.png" alt='University of Missouri'></a>
      <a class="navbar-brand" target="_blank" href="https://www.rjionline.org"><img src="img/logo_rji_tiny.png" alt='Reynolds Journalism Institute'></a>
      Dojo
    </b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav v-if="state.user">
        <b-nav-item :to="{ name: 'document.list', params: {} }"><i class="fa fa-file mr-2"></i> Document Search</b-nav-item>
        <b-nav-item v-if="state.user.active_collection" :to="{ name: 'collection.view', params: {id:state.user.active_collection.id}}"><i class="fa fa-bookmark mr-2"></i> {{state.user.active_collection.name}}</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right v-if="state.user">
          <!-- Using button-content slot -->
          <template slot="button-content">
            <span style="font-weight: bold;">{{state.user.alias}} <em class='small' v-if="state.user.is_admin">(admin)</em></span>
          </template>
          <!-- <b-dropdown-item>
            <router-link :to="{ name: 'user.view', params: {id:state.user.id} }">Profile</router-link>
          </b-dropdown-item> -->
          <b-dropdown-item v-on:click="logout">Signout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import Relay from 'system/relay'
import Store from 'system/store'
export default {
  data(){
    return {
      state: Store.state
    }
  },
  methods: {
    logout: function(){
      Relay.get("SecureUser",{"act":"logout"},(response)=>{
        Relay.clearTokens()
        sessionStorage.clear()
        Store.commit("deauthorize")
        location.href="/"
      })
    },
  }
}
</script>
